export default __webpack_public_path__ + "static/media/Mustard.9c2d8e6a.jpg";